import img from '../assets/images/about_me_bg.jpg'
import avatar from '../assets/images/avatar.jpg'
import wave from '../assets/images/wave.png'

const AboutSection = () => {
    return (
        <div>
            <img src={wave} className={'w-screen'} alt=""/>
            <div id="About" className={'w-screen min-h-screen lg:px-20 md:px-12 px-4 relative md:pt-40 pt-24 pb-48'}>

                <h1 className={'font-sinhalaPrimary text-3xl mb-12 font-black lg:hidden block'}>ගුරුවරයා පිළිබද
                    විස්තර</h1>

                <div className={'flex flex-col-reverse lg:flex-row md:px-0 px-2'}>
                    <div className={'lg:w-2/3 w-full md:pr-28'}>
                        <h1 className={'font-sinhalaPrimary text-3xl mb-12 font-black lg:block hidden'}>ගුරුවරයා පිළිබද
                            විස්තර</h1>
                        <p style={{lineHeight: "40px"}} className={'text-[16px] text-text-secondary'}>මාතලේ සිරිමාවෝ
                            බණ්ඩාරනායක විද්‍යාලයෙන් ප්‍රාථමික අධ්‍යාපනය හදාරා ශිෂ්‍යත්ව විභාගය සමත්ව ද්වීතීක අධ්‍යාපනය
                            සදහා මාතලේ ශාන්ත තෝමස් විද්‍යාලයට ඇතුළත් වන ඔහු මාතලේ විද්‍යා විද්‍යාලයීය කඩයිම් විභාගයෙන්
                            දෙවන ස්ථානය ලබා සාමාන්‍ය පෙළ හා උසස් පෙළ සදහා මාතලේ විද්‍යා විද්‍යාලයට ඇතුළත් වන ලදි.
                            සාමාන්‍ය පෙළ විභාගයෙන් මාතලේ දිස්ත්‍රික් ප්‍රථම ස්ථානය හිමි කරගන්නා ඔහු උසස් පෙළ ජීව
                            විද්‍යාව අංශයෙන් ඉහළින්ම සමත්ව පේරාදෙණිය විශ්ව විද්‍යාලයේ විද්‍යා පීඨයට වරම් හිමිකරගන්නා
                            ලදි. ජීව විද්‍යා අංශයෙන් තම උපාධියත් , පශ්චාත් උපාධියත් පන්ති සාමාර්ථයක් සහිතව සම්පූර්ණ කරන
                            ලදි.
                            උසස් පෙළ හදාරන අවධියේ සිට උපකාරක පන්ති ක්ෂේත්‍රයට යොමුවන ඔහු අසීරු විෂයක් ලෙස දරුවන් අතර
                            ප්‍රසිද්ධ විද්‍යාව විෂය කෙටි ක්‍රම හා තමා භාවිතයට ගත් මතක තබා ගැනීමේ ඔහුටම ආවේණික නව
                            ක්‍රමවේදයන් භාවිතයෙන් දරුවන්ට පහසු විෂයක් බවට පත්කර ඇත.

                            2017 සිට මේ දක්වා වසර කිහිපයක්ම පෙන්වූ උකුවෙල හා මාතලේ 100% ප්‍රතිඵල පෙන්වූ විද්‍යාව
                            පාඨමාලාව වීම සදහා ගුරුවරයාගේ කැපවීම මෙන්ම පන්තියේ වැඩපිළිවෙලද දායක වූ බව නොඅනුමානය.</p>
                    </div>

                    <div className={'lg:w-1/3 w-full flex justify-end lg:px-0 sm:px-12 px-8 lg:mb-0 mb-16'}>
                        <div className={'relative h-max w-full'}>
                            <img src={img}
                                 className={'lg:w-[500px] sm:w-[95%] w-full sm:h-[500px] h-[250px] object-cover'}
                                 alt=""/>
                            <img src={avatar} alt=""
                                 className={'absolute md:w-[300px] md:h-[300px] sm:w-[220px] sm:h-[220px] 2-[180px] h-[180px] rounded-full border-8 ' +
                                     'border-white lg:-bottom-1/4 lg:-left-1/4 -left-14 -bottom-14 object-cover'}/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AboutSection